import { cachedFetch } from "../CachedFetch";

const SECONDS_IN_9_MONTHS = 9 * 30 * 24 * 60 * 60;

export default class CoinGeckoAdapter {
  public static async getCurrencyStats(currencyId: string, force?: boolean) {

    return await this.getSafely(async () => {
      const response = await cachedFetch(
        `https://api.coingecko.com/api/v3/coins/${currencyId}?localization=false&tickers=false&market_data=true&community_data=false&developer_data=true&sparkline=false`,
      );

      return response;
    }, {});
  }

  public static async getCurrencyPlotData(currencyId: string, force?: boolean) {
    const to = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);
    const from = to - SECONDS_IN_9_MONTHS;

    return await this.getSafely(async () => {
      const response = await cachedFetch(
        `https://api.coingecko.com/api/v3/coins/${currencyId}/market_chart/range?vs_currency=btc&from=${from}&to=${to}`,
        {ttlMs: 24 * 60 * 60 * 1000 } // cache 24 hours
      );

      return response;
    }, {});
  }

  public static async getTopCurrenciesByMarketCap(
    count: number,
    force?: boolean,
  ) {
    return await this.getSafely(async () => {
      const response = await cachedFetch(
        `https://api.coingecko.com/api/v3/coins/markets?vs_currency=btc&order=market_cap_desc&per_page=${count}&page=1&sparkline=false`,
      );

      return response;
    }, []);
  }

  private static async getSafely(
    callback: () => {},
    errorDefaultValue: {} | [],
  ) {
    try {
      const data = await callback();
      return data;
    } catch (e) {
      console.error("CoinGeckoAdapter error", e);
      return errorDefaultValue;
    }
  }
}
